export default __webpack_public_path__ + "a165ebd489f75a7371adc408d96a8faa.png";